import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
function LogIn() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        if (!email || !password) {
            setErrorMessage('Please enter both email and password.');
            return;
        }
        setIsSubmitting(true);
        const url = 'https://bntserver.bntfoundation.com/LogIn.php';
        axios.get(url, { params: { email, password } })
            .then((response) => {
                const data = response.data;
                console.log(data);
                console.log(data);
                if (data && data.success) {
                    localStorage.setItem('user', JSON.stringify(data));
                    navigate('/home');
                } else {
                    setErrorMessage((data && (data.message || data.error)) || 'Invalid email or password.');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setErrorMessage('An error occurred. Please try again.');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };
    return (
        <div className="main">
            <div className="homeContainer">
                <div
                    class="untree_co-hero inner-page container-fluid"
                    style={{
                        backgroundImage: `url('images/studentRegister.jpg')`,
                        zIndex: 1,
                    }}
                >
                    <div class="container-fluid ">
                        <div class="row align-items-center justify-content-center">
                            <div class="col-12">
                                <div class="row justify-content-center ">
                                    <div class="col-lg-6 text-center ">
                                        <h1
                                            class="heading text-white"
                                            data-aos="fade-up"
                                            data-aos-delay="100"
                                            style={{ marginTop: 140 }}
                                        >
                                            Login
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="untree_co-section logInBox">
                    <div class="container-fluid">
                        <div class="row mb-5 justify-content-center">
                            <div
                                class="col-lg-5 mx-auto order-1"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >

                                <form class="form-box" onSubmit={handleSubmit}>
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <label class="form-label">Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                class="form-control"
                                                placeholder="Enter your email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div class="col-12 mb-3">
                                            <label class="form-label">Password</label>
                                            <div class="input-group">
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    name="password"
                                                    class="form-control"
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-secondary"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                                >
                                                    {showPassword ? 'Hide' : 'Show'}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <label class="control control--checkbox">
                                                <input type="checkbox" className='mx-2 my-2'/>
                                                <span class="caption">Remember me</span>
                                                <div class="control__indicator"></div>
                                            </label>
                                        </div>
                                        {errorMessage && (
                                            <div class="col-12 mb-2">
                                                <div class="text-danger">{errorMessage}</div>
                                            </div>
                                        )}
                                        <div class="col-12">
                                            <button type='submit' class="btn btn-primary" disabled={isSubmitting}>
                                                {isSubmitting ? 'Logging in...' : 'Log In'}
                                            </button>
                                        </div>
                                        {/* <div class="col-12 mt-3">
                                            <h5>If you do not have an account, then</h5>
                                            <Link to={ROUTES.register.name}>
                                                Register Here
                                            </Link>
                                        </div> */}
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default LogIn;
